/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { jsx } from 'theme-ui'

export const Logo = () => {
  const data = useStaticQuery(graphql`
    query LogoQuery {
      file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE)
        }
      }
    }
  `)
  return (
    <GatsbyImage fadeIn="false" loading="eager" image={data.file.childImageSharp.gatsbyImageData} />
  )
}

export default Logo
